import { render } from "./ListadoDistribuidores.vue?vue&type=template&id=3bb70275"
import script from "./ListadoDistribuidores.vue?vue&type=script&lang=js"
export * from "./ListadoDistribuidores.vue?vue&type=script&lang=js"

import "./ListadoDistribuidores.vue?vue&type=style&index=0&id=3bb70275&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__